import React from 'react';

import { SanitizedHtml } from '.';

export const Popover = ({assets, accentColor,autoNumber,body,color,icon,id,index,left,subtitle,title,top}) => {

  return (
    <div 
      id={`${id}-popover-${index}`} 
      className="dinfos-hotspot__popover d-none" 
      style={{
        left: left + '%',
        top:top + '%',
      }}
      data-auto-x={true}
      data-top={top + '%'}
      data-theme={accentColor}
    >
      <button className="btn dinfos-btn dinfos-hotspot__close" type="button" aria-label="Close pop-up"><i className="fas fa-times"></i></button>
      <div className="dinfos-hotspot__popover-scroll">
        
        {icon && icon.src ?
          <div className="dinfos-hotspot__icon">
            <img src={assets[icon.src]} alt={icon.alt} data-src={icon.src} />
          </div>
        : '' }

        <h3 className="dinfos-hotspot__headline">
            {autoNumber ? 
              <span className="dinfos-hotspot__headline-num">{index + 1}. </span>
            : '' }
            {title}
        </h3>

        {subtitle ?  
          <div className="dinfos-hotspot__subheadline">
            <SanitizedHtml content={subtitle} />
          </div>
        : '' }

        <div className="dinfos-hotspot__body"><SanitizedHtml content={body} /></div>

      </div>
    </div>
  )
}